module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAANlJREFUOE/Nku1NAlEUBWc6oAQ7QCsQOtAK1A7sxFiB0MFSgXQgdmAJdnDMJbsE8PGRkBjfz93cuXPOe3Lh8cJ5/gkgySOwUlfnREoyAcbq6zpCkgDfwPQUJMk18A6ojgZAGbz1kBv1q2WS5Ar4AEbAvdptSkzyDLxUlN6kjDYnSQ3V5jJ4Umf1c+cWktTHhxYkyRK4BeZqGa/Pr2vcgizVad/RAF6od9tmLUCp1rYx0AHVR8X7BCbqTrTmQ+rzDpBa2BxuRtgrrnTLqNvffLCDcx7S0Q7+HPADHbRREb2WivcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrow-bottom.png
// module id = Ns0B
// module chunks = 1